// platform/src/components/mw/MwFeatureCard.tsx
//
// Card de feature numerada o iconográfica.
// Tokens consumidos desde styles/mw.css.

import type { ReactNode, CSSProperties } from 'react'
import { useState } from 'react'

interface MwFeatureCardProps {
  index?: number
  icon?: ReactNode
  title: string
  description: string
  className?: string
}

export function MwFeatureCard({ index, icon, title, description, className = '' }: MwFeatureCardProps) {
  const [hovered, setHovered] = useState(false)

  const cardStyle: CSSProperties = {
    background: 'var(--mw-surface)',
    borderColor: hovered ? 'var(--mw-border-strong)' : 'var(--mw-border)',
    transition:
      'transform var(--mw-duration-medium) var(--mw-ease), box-shadow var(--mw-duration-medium) var(--mw-ease), border-color var(--mw-duration-medium) var(--mw-ease)',
    transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
    boxShadow: hovered ? 'var(--mw-shadow-card-hover)' : 'var(--mw-shadow-card)',
  }

  return (
    <article
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`rounded-3xl p-7 md:p-8 h-full flex flex-col border ${className}`}
      style={cardStyle}
    >
      {index !== undefined && (
        <div
          className="mb-5"
          style={{
            color: 'var(--mw-accent)',
            fontSize: '2.25rem',
            lineHeight: 1,
            letterSpacing: '-0.03em',
            fontWeight: 700,
            fontFamily: 'var(--mw-font-display)',
          }}
        >
          {String(index).padStart(2, '0')}
        </div>
      )}
      {icon && index === undefined && (
        <div
          className="inline-flex h-11 w-11 items-center justify-center rounded-full mb-5"
          style={{ background: 'var(--mw-accent-soft)', color: 'var(--mw-accent)' }}
        >
          {icon}
        </div>
      )}
      <h3
        className="mb-3"
        style={{
          color: 'var(--mw-ink)',
          fontSize: '1.1875rem',
          lineHeight: 1.25,
          letterSpacing: '-0.015em',
          fontWeight: 600,
          fontFamily: 'var(--mw-font-display)',
        }}
      >
        {title}
      </h3>
      <p
        style={{
          color: 'var(--mw-ink-secondary)',
          fontSize: '0.9375rem',
          lineHeight: 1.6,
          fontFamily: 'var(--mw-font-body)',
        }}
      >
        {description}
      </p>
    </article>
  )
}
